import { appendSource } from './appendSource';
export async function appendWebSource(fileCollection, webSourceURL, options = {}) {
    const response = await fetch(webSourceURL);
    const webSource = (await response.json());
    return appendSource(fileCollection, webSource, {
        baseURL: webSourceURL,
        ...options,
    });
}
//# sourceMappingURL=appendWebSource.js.map